import { render, staticRenderFns } from "./GroupsDataTable.vue?vue&type=template&id=4a5342aa"
import script from "./GroupsDataTable.vue?vue&type=script&lang=ts"
export * from "./GroupsDataTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports